export interface ProductoTerminSolicitanteDTO{
    iddecinvproductoterminsolicitante: number,
    iddecinvproyectoprodtermin: number,
    nombre: string,
    porcentajetitularidad: number,
    ultimoCambio: string,
}

export function getVoidProductoTerminSolicitante(): ProductoTerminSolicitanteDTO{
    return{
        iddecinvproductoterminsolicitante: 0,
        iddecinvproyectoprodtermin: 0,
        nombre: '',
        porcentajetitularidad: 0,
        ultimoCambio: ""
    }
}

export function setProductoTerminSolicitante(data: any): ProductoTerminSolicitanteDTO{
    return{
        iddecinvproductoterminsolicitante: data.iddecinvproductoterminsolicitante??0,
        iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
        nombre: data.nombre??'',
        porcentajetitularidad: data.porcentajetitularidad??0,
        ultimoCambio: data.ultimoCambio??""
    }
}

export function setListProductoTerminSolicitante(data: Array<any>):Array<ProductoTerminSolicitanteDTO>{
    let list: Array<ProductoTerminSolicitanteDTO> = [];
    data.forEach((item) => {
        const solicitanteDTO: ProductoTerminSolicitanteDTO = setProductoTerminSolicitante(item)
        list.push(solicitanteDTO);
    });
    return list;
}